import React, { useState } from 'react';
import { string } from 'prop-types';
import { Image } from '@thd-olt-component-react/core-ui';
import {
  params,
  shape,
  string as stringType,
  extend,
  useDataModel,
  bool,
  arrayOf as arrayType,
} from '@thd-nucleus/data-sources';
import { useStore } from '@thd-nucleus/experience-context';
import { ProductPod } from '@thd-olt-component-react/product-pod';
import styles from './tools-materials.module.scss';
import { SecondCall } from './SecondCall';
import { FirstCall } from './FirstCall';

const ToolsMaterials = ({ articleGUID }) => {
  const { storeId } = useStore();
  const {
    data,
  } = useDataModel('article', {
    variables: { articleGUID },
  });

  const artType = data?.article?.articleType;
  const prodList = data?.article?.relatedProducts || [];
  const prodUrls = prodList.map((prod) => prod.url);
  const nValues = prodUrls.map((url) => url.substr(url.lastIndexOf('/') + 1));
  const firstThreeNvalues = [nValues.slice(0, 3)] || [[]];

  const [isHidden, showHide] = useState(!(artType === 'ah'));
  const [seeMore, setSeeMore] = useState(false);

  const [threeNValues] = firstThreeNvalues;

  const { data: firstCallData } = useDataModel('dynamicRecs', {
    variables: { nValue: threeNValues, storeID: storeId },
  });

  const firstCallList = firstCallData?.dynamicRecs?.products || [];
  const firstCallItemIds = firstCallList.map((products) => products.id);

  const { data: secondCallData } = useDataModel('dynamicRecs', {
    variables: { nValue: nValues, storeID: storeId },
    skip: !seeMore
  });

  const secondCallList = secondCallData?.dynamicRecs?.products || [];
  const secondCallItemIds = secondCallList.map((products) => products.id);

  const isProjectGuide = artType === 'ah';
  const showFirstCall = !seeMore && firstCallItemIds.length > 0;
  const showSecondCall = seeMore && secondCallItemIds.length > 0;

  const productCard = (product, index) => {
    return (
      <div
        key={`related-products-${index}`}
        className={`${styles.product_card}${index > 5 && isHidden ? ` ${styles.hidden_card}` : ''}`}
      >
        <a href={product?.url}>
          <div className={styles.product_thumb}>
            <Image
              src={product.imageURL}
              alt={product.title}
              title=""
              height={85}
              width={85}
              className=""
            />
          </div>
        </a>
        <a href={product?.url}>
          <h3 className={styles.product_title}>{product?.title}</h3>
        </a>
      </div>
    );
  };

  if (!(prodList.length > 0)) {
    return null;
  }

  if (isProjectGuide) {
    return (
      <div className={styles.tools_materials} style={{ padding: '40px 10px' }}>
        <h2>Shop this Project</h2>

        <div id="atc-products" style={{ maxHeight: '1165px', overflowY: 'scroll' }}>
          {showFirstCall && <FirstCall itemIds={firstCallItemIds} storeId={storeId} /> }
          {showSecondCall && <SecondCall itemIds={secondCallItemIds} storeId={storeId} />}
          {seeMore ? (
            <div />
          ) : (
            <div className={styles.button_container}>
              <button
                id="see-more-products"
                type="button"
                className={styles.see__more__forAtc}
                onClick={() => setSeeMore(true)}
              >
                See More
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
  if (!isProjectGuide) {
    return (
      <div className={styles.tools_materials}>
        <h2>{artType === 'ap' ? 'Shop this Project' : 'Related Products'}</h2>
        {prodList.map((product, i) => productCard(product, i))}
        {prodList.length > 6 && (
          <div className={styles.button_container}>
            <button type="button" className={styles.see_more} onClick={() => showHide(!isHidden)}>
              See {isHidden ? 'More' : 'Less'}
            </button>
          </div>
        )}
      </div>
    );
  }
  return '';
};

ToolsMaterials.propTypes = {
  articleGUID: string.isRequired,
};

ToolsMaterials.displayName = 'ToolsMaterials';
const product = extend({}, ProductPod.dataModel.product);
ToolsMaterials.dataModel = {
  article: params({ articleGUID: stringType().isRequired() }).shape({
    articleType: stringType(),
    relatedProducts: arrayType(
      shape({
        imageURL: stringType(),
        isMaterial: bool(),
        title: stringType(),
        url: stringType(),
      })
    ),
  }),
  dynamicRecs: params({
    nValue: arrayType(stringType()),
    storeID: stringType().isRequired(),
  }).shape({
    products: arrayType(
      shape({
        id: stringType(),
      })
    ),
  }),
  searchModel: params({
    itemIds: arrayType(stringType()).isRequired(),
    storeId: stringType(),
  }).shape({
    products: arrayType(shape(product)),
  }),
};
export { ToolsMaterials };
